<script>
	import SubscribeCard from '../SubscribeCard.svelte';
	import RelatedBlogCard from './RelatedBlogCard.svelte';
	import PopularCard from '../PopularCard.svelte';
	import { onMount } from 'svelte';
	import { fetchAPI } from '../../../lib/fetchAPI';
	import { page } from '$app/stores';
	export let data;

	function formatDate(date) {
		return date.split('T')[0];
	}

	let url = `${import.meta.env.VITE_URL}/communitychronicle/${data.slug}`;
	let fb_url = encodeURI(`https://facebook.com/sharer/sharer.php?u=${url}&quote=testt`);
	let twitter_url = encodeURI(`https://twitter.com/intent/tweet/?text=${data.subject}&url=${url}`);
	let linkedin = encodeURI(`https://linkedin.com/shareArticle?mini=true&url=${url}&title=${data.subject}`)

	let related_data = {
		category_id: data.categories[0].id,
		blog_id: data.id
	};

	let suggest = false;

	onMount(async () => {
		let res = await fetchAPI('/communitychronicle/list_relevant', 'POST', related_data, false);
		console.log('Response ' + res.ok);
		suggest = await res.json();
	});

	let showMore = true;

	function handleEncodeCaracters(s) {
		return s.replace(/&#8217;/g, "'");
	}

	function getDescription() {
		return data.meta_description
	}

	function formatUrl(scale, img_id) {
		let formatedUrl = `${
			import.meta.env.VITE_API_URL
		}/communitychronicle/image/${img_id}?scaley=${scale}&encoding=webp`;
		return formatedUrl;
	}


	function getKeywords() {
		return data.keywords;
	}
</script>

<svelte:head>
	<title>{data.subject} | Community Lands</title>
	<meta name="description" content={getDescription()} />
	<meta property="og:title" content={`${data.subject} | Community Lands`} />
	<meta property="og:description" content={getDescription()} />
	<meta name="twitter:title" content={`${data.subject} | Community Lands`} />
	<meta name="twitter:description" content={getDescription()} />
	<meta name="keywords" content={getKeywords()}>
	<!-- TODO: Add article specific image -->
</svelte:head>

<div class="return-holder">
	<div />
	<a href="/communitychronicle">The Community Chronicle</a>
</div>

<div class="artical-container">
	<div>
		<div class="title">
			<h1>{handleEncodeCaracters(data.subject)}</h1>
			<div class="sub-title">
				<h2>{data.author.first_name + ' ' + data.author.last_name}</h2>
				<h2>{formatDate(data.date_modified)}</h2>
			</div>
		</div>

		<img src="{formatUrl(475, data.blog_images[0].id)}" alt="" class="main-img" />
		<div class="sub-card">
			<div>
				<SubscribeCard />
				<div class="artical-content">
					{@html data.content}
				</div>
			</div>

			{#if suggest != false}
				<div class="popular-list">
					<PopularCard bind:showMore bind:data={suggest} bind:skipBlog={related_data.blog_id} />
				</div>
			{/if}
		</div>
		<div class="social-shere">
			<p>Share:</p>
			<a href={fb_url} target="_blank" rel="noreferrer">
				<img src="/fb-logo.svg" alt="fb-logo" />
			</a>
			<a href={twitter_url} target="_blank" rel="noreferrer">
				<img src="/twiter-logo.svg" alt="twiter-logo" />
			</a>
			<a href={linkedin} target="_blank" rel="noreferrer"> 
				<img src="/linkedin.svg" alt=""/>
			</a>
			
		</div>

		<div class="related">
			<h1>Related Articles</h1>
			<div class="related-cards">
				{#if suggest}
					<RelatedBlogCard bind:data={suggest} />
				{/if}
			</div>
		</div>
	</div>
</div>

<style>
	.related-cards {
		display: flex;
		column-gap: 54px;
		justify-content: center;
	}
	.artical-content {
		width: 708px;
		text-align: justify;
		margin-top: 16px;
		margin-bottom: 30px;
		font-size: 20px;
	}

	.popular-list {
		margin-left: 33px;
	}
	.related h1 {
		text-align: center;
		font-weight: 600;
		font-size: 27px;
		line-height: 37px;
	}
	.social-shere a {
		all: unset;
		cursor: pointer;
		display: flex;
	}
	.social-shere {
		width: 294px;
		height: 55px;
		background: #ffffff;
		border: 1px solid #667779;
		border-radius: 20px;
		display: flex;
		align-items: center;
	}
	.social-shere p {
		margin-right: 10px;
		margin-left: 12px;
	}
	.social-shere img, .social-shere svg {
		height: 39px;
		width: 39px;
		margin-right: 8px;
	}

	#whatsapp {
		fill: #25d366;
	}
	.sub-card {
		width: 758px;
		display: flex;
	}
	a {
		font-weight: 600;
		font-size: 27px;
		line-height: 37px;
	}
	.artical-container {
		width: 75%;
		margin: 0 auto;
	}
	.title {
		width: 80%;
		height: 110px;
	}

	.title h1 {
		font-weight: 700;
		font-size: 40px;
		line-height: 54px;
		margin-bottom: 0;
	}

	.sub-title {
		width: 97%;
		display: flex;
		justify-content: space-between;
	}

	.sub-title h2 {
		font-weight: 400;
		font-size: 25px;
		line-height: 34px;
	}
	.main-img {
		border-radius: 20px;
		width: 78%;
		height: 500px;
		margin-bottom: 30px;
	}

	.return-holder a {
		all: unset;
		color: #000;
		font-weight: 600;
		font-size: 27px;
		line-height: 37px;
	}

	.return-holder div {
		background-image: url('/returnarrow.svg');
		background-repeat: no-repeat;
		width: 30px;
		height: 30px;
		font-weight: 400;
		font-size: 40px;
		line-height: 40px;
	}

	.return-holder {
		cursor: pointer;
		display: flex;
		flex-direction: row;
		height: auto;
		align-items: flex-end;
		width: 30%;
		justify-content: center;
	}

	:global(.artical-content img) {
		width: 708px;
	}

	:global(.artical-content a) {
		all: unset;
		color: #10b5d9;
		text-decoration: underline;
		cursor: pointer;
	}

	@media only screen and (max-width: 1546px) {
		.related-cards {
			column-gap: 20px;
		}
	}

	@media only screen and (max-width: 1374px) {
		.related-cards {
			column-gap: 5px;
			column-gap: 10px;
		}
	}

	@media only screen and (max-width: 1292px) {
		.related-cards {
			column-gap: 5px;
		}

		.related-cards {
			width: 100%;
			overflow-y: scroll;
			column-gap: 3rem;
			box-sizing: border-box;
			padding: 1rem 0;
		}
	}

	@media only screen and (max-width: 1260px) {
		.artical-container {
			width: 1050px;
			margin: 0 auto;
		}
	}

	@media only screen and (max-width: 1224px) {
		.return-holder a {
			white-space: nowrap;
		}
	}

	@media only screen and (max-width: 1156px) {
		.related-cards {
			justify-content: unset;
			column-gap: 7px;
		}
		.popular-list {
			display: none;
		}

		.title {
			margin: 0 auto;
		}

		.main-img {
			display: block;
			margin: 0 auto;
			width: 83%;
			margin-bottom: 1.2rem;
		}

		.sub-card {
			width: unset;
			display: flex;
			justify-content: center;
		}

		.social-shere {
			margin: 0 3rem;
		}

		.return-holder {
			width: 40%;
		}
	}

	@media only screen and (max-width: 1037px) {
		.artical-container {
			width: 90%;
		}
	}

	@media only screen and (max-width: 877px) {
		.return-holder {
			min-width: 50%;
		}
	}

	@media only screen and (max-width: 825px) {
		.title,
		.main-img,
		.sub-card,
		.sub-card div,
		:global(.artical-content img) {
			width: 100%;
			object-fit: cover;
		}

		.social-shere {
			margin: unset;
		}
	}

	@media only screen and (max-width: 690px) {
		.return-holder {
			min-width: 60%;
		}

		.social-shere {
			margin: unset;
		}
	}

	@media only screen and (max-width: 566px) {
		.return-holder {
			width: 70%;
		}
	}

	@media only screen and (max-width: 524px) {
		.sub-card div {
			height: 100%;
		}
	}

	@media only screen and (max-width: 495px) {
		.return-holder {
			width: 80%;
		}
	}

	@media only screen and (max-width: 428px) {
		.return-holder {
			width: 90%;
		}
	}

	@media only screen and (max-width: 384px) {
		.return-holder a {
			font-size: 22px;
		}

		.related-cards {
			justify-content: center;
		}
	}
</style>
